// Functions.
import { observe } from './general/observe';
import { prerequisitesDefine, prerequisitesResolve } from './general/prerequisites'
import {
	addNewAdSlotDefineFunc,
	addNewAdSlot,
	updateAdSlot,
	updateAdSlotValue,
	getAdSlot,
	getAdSlots,
} from './general/ad-slot-storage';
import { adTechLog } from './general/log';
import { onDOMLoad, onDOMComplete } from './general/dom-events'
import { onLazyLoad } from './general/lazyload';
import { delayCallback } from './general/delay';

// Services.
import { googletag } from './services/googletag';
import { moatIsOn, moatSafetyDataAvailable, moatSetTargetingForAllSlots } from './services/moat';

const { prerequisitesTimeoutInSeconds } = window.adTechConfig;

let prerequisitesTimeoutInSecondsFloat = parseFloat( prerequisitesTimeoutInSeconds );

// Set a default.
if ( isNaN( prerequisitesTimeoutInSecondsFloat ) ) {
	prerequisitesTimeoutInSecondsFloat = 1.0;
}

/**
 * define ad slots and store them.
 * display ad slots if they have been stored.
 */

/**
 * Use a window object rather than a class so that the entire site has
 * access to the functionality and the object parameters.
 */
window.adTech = window.adTech || { cmd: [] }
window.adTech = {
	cmd: window.adTech.cmd,

	// Add the custom service functions.
	// Only load what is used. Not the whole object for the below services.
	googletag,
	moatSetTargetingForAllSlots,

	// Initialize.
	init: () => {

		// Start observing the ads being loaded after the requirements have been met,
		// both those that have been pre loaded and those to come.
		prerequisitesResolve( prerequisitesDefine, prerequisitesTimeoutInSecondsFloat * 1000 ).then( () => {

			adTechLog( {
				type: 'step',
				message: 'Start Observing',
			} );

			// Log the status of Moat service.
			adTechLog( {
				type: 'info',
				message: 'Moat is ' + ( moatIsOn() ? 'enabled' : 'disabled' ) + '.',
			} );

			// Set the moat targeting if it hasn't been done .
			// Check "safetyDataAvailable".
			if ( ! moatSafetyDataAvailable() ) {
				moatSetTargetingForAllSlots();
			}

			// Observe all functions pushed to cmd array.
			observe( window.adTech.cmd );

			// Add resize event.
			window.addEventListener('resize', () => {
				delayCallback( () => {
					window.googletag.cmd.push( function() {

						// Do not refresh ads on mobile devices.
						if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
							return;
						}

						window.googletag.pubads().refresh();
					} );
				}, 1500 );
			} );
		} );
	},

	// Storage functions.
	addNewAdSlotDefineFunc,
	addNewAdSlot,
	updateAdSlot,
	updateAdSlotValue,
	getAdSlot,
	getAdSlots,

	// Logger.
	log: adTechLog,

	// Functions.
	onDOMLoad,
	onDOMComplete,
	onLazyLoad,
}

// Start the adTech layer.
window.adTech.init();
